import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../topic/redux/actions';
import StyleTwoSectionTitle from './StyleTwoSectionTitle'
import StyleTwoClassTables from './StyleTwoClassTables'

export class StyleTwoClass extends Component {
  static propTypes = {
    topic: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    list: {},
    defaultIndex: 1,
  }
  componentWillMount() {
    this.setState({ list: this.props.itemsData });
  }
  toggleTabs(id) {
    let { list } = this.state;
    list.list.map(item => {
      if (item.id === id) {
        item.active = true;
      } else {
        item.active = false;
      }
    })
    this.setState({ defaultIndex: id, list })
  }
  render() {
    let { list, defaultIndex } = this.state;
    let { onMeiQiaCustomer, colorData } = this.props;
    return (
      <div className="topic-style-two-class" style={{ background: `url(${list.totalbackImg}) no-repeat`, backgroundSize: 'cover' }}>
        <a name={list.name}><StyleTwoSectionTitle isColorW={false} Data={list} /></a>
        <div className='class_section_box'>
          <div className='class_tabs flex_row' style={{ borderBottom: `2px solid ${colorData.color}` }}>
            {list.list && list.list.map(item => <div className={item.active ? 'class_tabs_item active flex_row' : 'class_tabs_item flex_row'} style={{ backgroundImage: item.active ? colorData.backgroundImage : '' }} key={item.id} onClick={this.toggleTabs.bind(this, item.id)}>{item.title}</div>)}
          </div>
          <div className='class_content_box'>
            <StyleTwoClassTables Data={list.list[defaultIndex - 1]} onMeiQiaCustomer={onMeiQiaCustomer} colorData={colorData} />
          </div>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    topic: state.topic,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StyleTwoClass);



// WEBPACK FOOTER //
// ./src/features/style-two/StyleTwoClass.js